/* sv-cart-kod (koszyk /cart, sesja 7ea9476e, 10.10.2026): pole na kod rabatowy na stronie /cart; opis w snippets/sv-cart-kod.liquid.
   - Nakładanie i usuwanie: POST cart/update.js { discount: 'KOD1,KOD2' } (oficjalne Cart AJAX API Shopify od 05.2025; lista
     zastępuje obecne kody, pusty tekst usuwa wszystkie). Stan kodów brany świeżo z cart.js (discount_codes), nie z DOM.
   - Kody, których klientka nie dotyka (także nieprzyjęte jeszcze kody z linku /discount/KOD, np. z warunkiem kwoty), zostają.
   - Kod, którego koszyk nie przyjmie (applicable: false albo brak w odpowiedzi), od razu zdejmujemy (wracamy do poprzedniej
     listy), żeby kasa nie pokazywała nieważnego kodu, i pokazujemy komunikat. Kody na zamówienie (vibe5, kody twórczyń:
     combinesWith.orderDiscounts = false) nie łączą się ze sobą: nowy kod nie wchodzi, a sam działa = „nie łączy się z X”;
     nowy wchodzi i wyłącza działający stary = stary zdejmujemy i mówimy o tym.
   - Kod przyjęty, ale bez rabatu w koszyku (rabat na dostawę - liczy się w kasie po wyborze dostawy): zostaje, komunikat.
   - Przerysowanie: sekcje z tej samej odpowiedzi, przez cart-items z assets/cart.js (getSectionsToRender / getSectionInnerHTML,
     ten sam sposób co zmiana ilości), plus ukryta szuflada (sekcja cart-drawer, jak render() w assets/cart-gift.js; ikona
     koszyka na /cart otwiera szufladę, a zdarzenie ze źródłem 'cart-items' jej nie odświeża - audyt D 10.10 pkt 2), potem
     pasek dostawy i cartUpdate ze źródłem 'cart-items' (assets/cart-gift.js sprawdza wtedy prezent).
   - Kasa czeka na koniec akcji: window.svCheckoutHold() z assets/cart-gift.js (najdłużej 5 s), żeby „Realizuj zakup” w trakcie
     nie zabrał do kasy stanu pośredniego (przegląd G 10.10, W1).
   - Błąd sieci w połowie akcji: widok wraca do stanu z serwera (sekcje GET cart?sections=), komunikat „błąd” (G W2).
   - Element powstaje na nowo przy każdym przerysowaniu stopki (także przez cart-gift.js), dlatego blokada „w toku”, komunikat
     po akcji i wpisywany kod żyją w zmiennych modułu.
   - Analityka: window.svTrack (assets/sv-events.js) - zdarzenie sv_cart_code { action, result, code }; kod tylko przy wynikach
     potwierdzających prawdziwy kod (dowolny tekst klientki, np. e-mail wpisany przez pomyłkę, nie trafia do GA4 - G D5),
     a kod jednorazowy z Klaviyo (przypisany jednej osobie) idzie jako „JEDNORAZOWY”, nie sam kod. */
(function () {
  if (window.customElements.get('sv-cart-kod')) return;

  var R = window.routes || {};
  var URL_CART = (R.cart_url || '/cart') + '.js';
  var URL_UPDATE = (R.cart_update_url || '/cart/update') + '.js';
  var TIMEOUT_MS = 15000;
  var FLASH_MS = 6000;
  var DRAFT_MS = 120000;
  var pending = false;
  // komunikat po akcji: { typ: 'ok' | 'blad', tekst, focus: 'summary' | 'input' | null, until, sr }; sr = tylko dla czytnika ekranu
  // (uwaga CEO 10.10: nazwa kodu widoczna 3 razy - przy zwykłym dodaniu i usunięciu potwierdzeniem są plakietka i kwota na liście)
  var flash = null;
  // wpisywany kod: przerysowanie stopki w trakcie pisania nie może go zgubić { value, open, focused, t }
  var draft = null;
  var kodHash = false;
  var KOD_W_ANALITYCE = { applied: 1, replaced: 1, shipping: 1, already: 1, removed: 1, not_combinable: 1 };
  // kody jednorazowe z Klaviyo (vibe5, NASTEPNY15, COMEBACK15 itd.): zawsze 8 znaków bez samogłosek, Y, 0 i 1 (sprawdzone 10.10
  // na 941 kodach z 314 rabatów wielokodowych w sklepie; żaden ze 116 kodów nazwanych, np. SANDRA10 czy AUREA100, tego nie spełnia)
  var KOD_JEDNORAZOWY = /^[2-9BCDFGHJKLMNPQRSTVWXZ]{8}$/;

  function upper(code) {
    return String(code || '').trim().toUpperCase();
  }

  function same(a, b) {
    return upper(a) === upper(b);
  }

  // kod do GA4: tylko przy wynikach potwierdzających prawdziwy kod; jednorazowy jako typ (mniej wartości w raportach, bez kodu osoby)
  function analyticsCode(result, code) {
    if (!KOD_W_ANALITYCE[result]) return null;
    var c = upper(code);
    return KOD_JEDNORAZOWY.test(c) ? 'JEDNORAZOWY' : c.slice(0, 40);
  }

  function track(action, result, code) {
    try {
      if (typeof window.svTrack !== 'function') return;
      var data = { action: action, result: result };
      var c = analyticsCode(result, code);
      if (c) data.code = c;
      window.svTrack('sv_cart_code', data);
    } catch (e) {}
  }

  function hold() {
    return typeof window.svCheckoutHold === 'function' ? window.svCheckoutHold() : function () {};
  }

  function request(url, body) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl
      ? setTimeout(function () {
          ctrl.abort();
        }, TIMEOUT_MS)
      : null;
    var opts = { headers: { Accept: 'application/json' } };
    if (ctrl) opts.signal = ctrl.signal;
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(
        function (d) {
          if (timer) clearTimeout(timer);
          return d;
        },
        function (e) {
          if (timer) clearTimeout(timer);
          throw e;
        }
      );
  }

  function allCodes(cart) {
    return (cart.discount_codes || []).map(function (d) {
      return d.code;
    });
  }

  function appliedCodes(cart) {
    return (cart.discount_codes || [])
      .filter(function (d) {
        return d && d.applicable !== false;
      })
      .map(function (d) {
        return d.code;
      });
  }

  function findCode(cart, code) {
    return (cart.discount_codes || []).find(function (d) {
      return upper(d.code) === upper(code);
    });
  }

  // czy kod daje rabat widoczny w koszyku (na zamówienie albo na pozycję); rabat na dostawę tu nie występuje.
  // Uwaga: odpowiedź cart/update.js ma cart_level_discount_applications w kształcie { amount, discount_application: { title } },
  // a cart.js płasko { title } (sprawdzone 10.10 na kopii testowej) - obsługujemy oba; do tego items[].discounts[].title.
  function hasDiscountInCart(cart, code) {
    var c = upper(code);
    function title(a) {
      return a && (a.discount_application ? a.discount_application.title : a.title);
    }
    var found = (cart.cart_level_discount_applications || []).some(function (a) {
      return upper(title(a)) === c;
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (al) {
        if (upper(title(al)) === c) found = true;
      });
      (item.discounts || []).forEach(function (d) {
        if (upper(d && d.title) === c && d.amount > 0) found = true;
      });
    });
    return found;
  }

  function sectionTargets() {
    var ci = document.querySelector('cart-items');
    if (!ci || typeof ci.getSectionsToRender !== 'function') return null;
    try {
      return { ci: ci, list: ci.getSectionsToRender() };
    } catch (e) {
      return null;
    }
  }

  // sekcje strony koszyka (4) + szuflada = 5, limit Shopify dla sekcji w jednej odpowiedzi Cart API
  function sectionIds() {
    var t = sectionTargets();
    var ids = t
      ? t.list.map(function (s) {
          return s.section;
        })
      : [];
    if (document.querySelector('cart-drawer') && ids.indexOf('cart-drawer') === -1) ids.push('cart-drawer');
    return ids.slice(0, 5);
  }

  function render(data) {
    var t = sectionTargets();
    if (!t || !data.sections) {
      window.location.reload();
      return;
    }
    t.list.forEach(function (s) {
      var html = data.sections[s.section];
      var host = document.getElementById(s.id);
      if (!html || !host) return;
      var target = host.querySelector(s.selector) || host;
      try {
        target.innerHTML = t.ci.getSectionInnerHTML(html, s.selector);
      } catch (e) {}
    });
    // ukryta szuflada na /cart (otwiera ją ikona koszyka): ta sama treść co po stronie
    var dHtml = data.sections['cart-drawer'];
    var drawer = document.querySelector('cart-drawer');
    if (dHtml && drawer) {
      try {
        var fresh = new DOMParser().parseFromString(dHtml, 'text/html').querySelector('.drawer__inner');
        var cur = drawer.querySelector('.drawer__inner');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          drawer.classList.toggle('is-empty', !!cur.querySelector('cart-drawer-items.is-empty') || !cur.querySelector('.cart-item'));
        }
      } catch (e) {}
    }
    if (typeof t.ci.updateProgressBar === 'function') {
      try {
        t.ci.updateProgressBar({ total_price: data.total_price, items_subtotal_price: data.items_subtotal_price });
      } catch (e) {}
    }
    // PUB_SUB_EVENTS to const z assets/constants.js (nie właściwość window), publish z assets/pubsub.js
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: data });
    }
  }

  // po błędzie w połowie akcji: strona wraca do stanu z serwera (koszyk mógł się już zmienić)
  function resync() {
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    return request((R.cart_url || '/cart') + '?sections=' + encodeURIComponent(ids.join(',')))
      .then(function (sections) {
        return request(URL_CART).then(function (cart) {
          cart.sections = sections;
          render(cart);
        });
      })
      .catch(function () {});
  }

  function current(el) {
    return el && el.isConnected ? el : document.querySelector('#main-cart-footer sv-cart-kod');
  }

  class SvCartKod extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.form = this.querySelector('.sv-kod__form');
      this.input = this.querySelector('input[name="discount"]');
      this.button = this.querySelector('.sv-kod__button');
      this.msg = this.querySelector('.sv-kod__komunikat');
      this.details = this.querySelector('details');
      if (!this.form || !this.input || !this.button || !this.msg) return;
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      var me = this;
      this._focused = false;
      this.input.addEventListener('focus', function () {
        me._focused = true;
      });
      this.input.addEventListener('blur', function () {
        me._focused = false;
      });
      if (draft && Date.now() - draft.t < DRAFT_MS && !this.input.value) {
        var dr = draft;
        draft = null;
        if (dr.value) this.input.value = dr.value;
        if (dr.open && this.details) this.details.open = true;
        if (dr.focused) this.input.focus({ preventScroll: true });
      }
      // link „Masz kod rabatowy?” z szuflady prowadzi na /cart#kod (wizja K2): pole otwarte i gotowe do pisania
      if (window.location.hash === '#kod' && this.details && !kodHash) {
        kodHash = true;
        this.details.open = true;
        this.input.focus({ preventScroll: true });
        this.scrollIntoView({ block: 'center' });
      }
      if (flash && Date.now() < flash.until) {
        var f = flash;
        if (this.details) this.details.open = true;
        // region role=status jest w drzewie od wstawienia; tekst po chwili, żeby czytnik ekranu ogłosił zmianę
        setTimeout(function () {
          me.show(f.typ, f.tekst, f.sr);
        }, 50);
        // fokus tylko raz i tylko gdy zniknął razem z przerysowaną stopką (inaczej nie zabieramy go klientce)
        if (f.focus && (!document.activeElement || document.activeElement === document.body)) {
          var target = f.focus === 'input' ? this.input : this.querySelector('summary');
          if (target) target.focus({ preventScroll: true });
        }
        f.focus = null;
      }
    }

    disconnectedCallback() {
      if (!this.input) return;
      if (this.input.value || this._focused) {
        draft = { value: this.input.value, open: this.details ? this.details.open : false, focused: this._focused, t: Date.now() };
      }
    }

    text(name, code, other) {
      var t = this.dataset['msg' + name] || '';
      if (code) t = t.split('[code]').join(code);
      if (other) t = t.split('[other]').join(other);
      return t;
    }

    show(typ, tekst, sr) {
      if (!this.msg) return;
      this.msg.classList.toggle('sv-kod__komunikat--sr', !!sr);
      if (typ) this.msg.dataset.typ = typ;
      else delete this.msg.dataset.typ;
      this.msg.querySelector('.sv-kod__tekst').textContent = tekst || '';
      if (typ === 'blad') this.input.setAttribute('aria-invalid', 'true');
      else this.input.removeAttribute('aria-invalid');
    }

    // błąd zostaje też po przerysowaniu stopki w trakcie akcji (flash z fokusem na polu)
    fail(tekst) {
      flash = { typ: 'blad', tekst: tekst, focus: 'input', until: Date.now() + FLASH_MS };
      var el = current(this);
      if (!el || !el.input) return;
      el.show('blad', tekst);
      if (el.details) el.details.open = true;
      el.input.focus({ preventScroll: true });
      el.input.select();
      flash.focus = null;
    }

    busy(on) {
      this.setAttribute('aria-busy', on ? 'true' : 'false');
      this.input.readOnly = on;
      this.button.classList.toggle('loading', on);
      this.button.setAttribute('aria-disabled', on ? 'true' : 'false');
      var sp = this.button.querySelector('.loading__spinner');
      if (sp) sp.classList.toggle('hidden', !on);
      this.querySelectorAll('.sv-kod__usun').forEach(function (b) {
        b.setAttribute('aria-disabled', on ? 'true' : 'false');
      });
    }

    onSubmit(event) {
      event.preventDefault();
      if (pending) return;
      var code = this.input.value.trim();
      if (!code) {
        this.fail(this.text('Empty'));
        return;
      }
      this.apply(code);
    }

    onClick(event) {
      var btn = event.target.closest('.sv-kod__usun');
      if (!btn) return;
      event.preventDefault();
      if (pending) return;
      var pill = btn.closest('.sv-kod__pill');
      if (pill && pill.dataset.code) this.remove(pill.dataset.code);
    }

    finish(release) {
      release();
      pending = false;
      var el = current(this);
      if (el && el.button) el.busy(false);
    }

    apply(code) {
      var self = this;
      var beforeAll = [];
      var beforeOk = [];
      var release = hold();
      pending = true;
      flash = null;
      this.show('', '');
      this.busy(true);
      request(URL_CART)
        .then(function (cart) {
          beforeAll = allCodes(cart);
          beforeOk = appliedCodes(cart);
          if (beforeOk.some(function (c) { return same(c, code); })) {
            track('apply', 'already', code);
            self.fail(self.text('Already', upper(code)));
            return null;
          }
          var list = beforeAll
            .filter(function (c) {
              return !same(c, code);
            })
            .concat([code]);
          return request(URL_UPDATE, { discount: list.join(','), sections: sectionIds(), sections_url: window.location.pathname });
        })
        .then(function (data) {
          if (!data) return null;
          var entry = findCode(data, code);
          if (!entry || entry.applicable === false) {
            // nieprzyjęty kod nie zostaje w koszyku (kasa pokazałaby błąd): wracamy do poprzedniej listy
            var revert = function () {
              return request(URL_UPDATE, { discount: beforeAll.join(',') });
            };
            if (!beforeOk.length) {
              track('apply', 'not_applicable', code);
              return revert().then(function () {
                self.fail(self.text('Invalid', upper(code)));
              });
            }
            // były działające kody: sprawdzamy kod sam - działa sam = nie łączy się z obecnym (Shopify zostawia lepszy rabat);
            // błąd sieci tutaj idzie do .catch (komunikat „błąd”, nie „kod nie działa”)
            return request(URL_UPDATE, { discount: code }).then(function (alone) {
              var e2 = findCode(alone, code);
              var conflict = !!(e2 && e2.applicable !== false);
              track('apply', conflict ? 'not_combinable' : 'not_applicable', code);
              return revert().then(function () {
                self.fail(
                  conflict
                    ? self.text('Conflict', upper(code), beforeOk.map(upper).join(', '))
                    : self.text('Invalid', upper(code))
                );
              });
            });
          }
          // przyjęty: działające wcześniej kody, które Shopify przez niego wyłączył (nie łączą się), zdejmujemy
          var dropped = beforeOk.filter(function (c) {
            var e = findCode(data, c);
            return !e || e.applicable === false;
          });
          var next = dropped.length
            ? request(URL_UPDATE, {
                discount: allCodes(data)
                  .filter(function (c) {
                    return !dropped.some(function (d) {
                      return same(d, c);
                    });
                  })
                  .join(','),
                sections: sectionIds(),
                sections_url: window.location.pathname
              })
            : Promise.resolve(data);
          return next.then(function (fin) {
            var shipping = !hasDiscountInCart(fin, code);
            var result = dropped.length ? 'replaced' : shipping ? 'shipping' : 'applied';
            track('apply', result, code);
            var tekst = dropped.length
              ? self.text('Replaced', upper(code), dropped.map(upper).join(', '))
              : self.text(shipping ? 'Shipping' : 'Applied', upper(code));
            flash = { typ: 'ok', tekst: tekst, focus: 'summary', until: Date.now() + FLASH_MS, sr: result === 'applied' };
            self.input.value = '';
            self._focused = false;
            draft = null;
            render(fin);
            // gdy stopka nie została przerysowana (np. sekcja nie przyszła), komunikat w obecnym elemencie
            if (self.isConnected) self.show(flash.typ, flash.tekst, flash.sr);
            return null;
          });
        })
        .catch(function () {
          track('apply', 'error', code);
          return resync().then(function () {
            self.fail(self.text('Error'));
          });
        })
        .then(function () {
          self.finish(release);
        });
    }

    remove(code) {
      var self = this;
      var release = hold();
      pending = true;
      flash = null;
      this.show('', '');
      this.busy(true);
      request(URL_CART)
        .then(function (cart) {
          var rest = allCodes(cart).filter(function (c) {
            return !same(c, code);
          });
          return request(URL_UPDATE, { discount: rest.join(','), sections: sectionIds(), sections_url: window.location.pathname });
        })
        .then(function (data) {
          track('remove', 'removed', code);
          flash = { typ: 'ok', tekst: self.text('Removed', upper(code)), focus: 'summary', until: Date.now() + FLASH_MS, sr: true };
          render(data);
          if (self.isConnected) self.show(flash.typ, flash.tekst, flash.sr);
        })
        .catch(function () {
          track('remove', 'error', code);
          return resync().then(function () {
            self.fail(self.text('Error'));
          });
        })
        .then(function () {
          self.finish(release);
        });
    }
  }

  window.customElements.define('sv-cart-kod', SvCartKod);

  /* przegląd (drobne 4): link „Masz kod rabatowy?” w szufladzie otwartej na samej stronie /cart zmienia tylko #kod - zamknij
     szufladę i otwórz pole */
  window.addEventListener('hashchange', function () {
    if (window.location.hash !== '#kod') return;
    var el = document.querySelector('#main-cart-footer sv-cart-kod');
    if (!el || !el.details) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active') && typeof drawer.close === 'function') drawer.close();
    el.details.open = true;
    setTimeout(function () {
      if (el.input) el.input.focus({ preventScroll: true });
      el.scrollIntoView({ block: 'center' });
    }, 350);
  });
})();
